/**
 * On-demand resolution for platform system agents (Stickyboard Steward, VAU Piere, …).
 *
 * Calls the Hypatia ensure endpoint, which publishes-if-absent and installs the agent as a
 * system agent when it isn't already present, then returns its per-instance UUID. This
 * decouples system-agent resolution from the specialized-agents list (which wouldn't contain
 * the agent until something installed it — the chicken-and-egg the ensure path fixes).
 */

import http from '@frontend/api/http';
import { HYPATIA_URL } from '@frontend/envConfig';

export type EnsureSystemAgentResponse = { agent_uuid: string | null };

export async function ensureSystemAgent(
  instanceId: string,
  agentId: string
): Promise<EnsureSystemAgentResponse> {
  const res = await http.post<EnsureSystemAgentResponse>(
    `${HYPATIA_URL}/api/v1/${encodeURIComponent(instanceId)}/system-agents/${encodeURIComponent(agentId)}/ensure`
  );
  return res.data;
}
